import { Exception } from './exception';

export class UnwrapException extends Exception {}
